import { defineNuxtPlugin } from 'nuxt/app';

export default defineNuxtPlugin(() => {
  // Removed vue-js-modal plugin: not compatible with Vue 3
});
